import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { User, Mail, Phone } from "lucide-react";

const fields = [
  {
    name: "fullName" as const,
    label: "Nom complet",
    placeholder: "Votre nom complet",
    type: "text",
    icon: <User size={16} />,
  },
  {
    name: "email" as const,
    label: "Email",
    placeholder: "votre@email.com",
    type: "email",
    icon: <Mail size={16} />,
  },
  {
    name: "phone" as const,
    label: "Téléphone",
    placeholder: "+33 6 00 00 00 00",
    type: "tel",
    icon: <Phone size={16} />,
  },
];

export const Step8Contact = () => {
  const form = useFormContext();

  return (
    <section className="space-y-6 w-full">
      <div className="flex flex-col gap-1 mb-2">
        <h1 className="font-h2 text-dark-blue">Vos coordonnées</h1>
        <p className="font-p text-muted-foreground">
          Pour recevoir votre proposition personnalisée sous 1h.
        </p>
      </div>

      <div className="space-y-4">
        {fields.map(({ name, label, placeholder, type, icon }) => (
          <FormField
            key={name}
            control={form.control}
            name={name}
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-sm font-semibold text-dark-blue">
                  {label}
                </FormLabel>
                <FormControl>
                  <div className="relative">
                    <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground">
                      {icon}
                    </div>
                    <Input
                      type={type}
                      placeholder={placeholder}
                      className="pl-10 h-12 bg-white rounded-xl border-2 focus:border-primary transition-colors"
                      {...field}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        ))}
      </div>

      <div className="bg-primary/8 border border-primary/20 rounded-xl p-4 text-sm text-dark-blue/70">
        🔒 Vos informations sont confidentielles et ne seront jamais partagées sans votre accord.
      </div>
    </section>
  );
};
